import React from 'react';
import {Button} from "fearless-common-ui";
import {DashLg, PlusLg} from "react-bootstrap-icons";
import AmountSpan from "./AmountSpan";

const iconSize = 20;

interface QuantitySelectorProps {
  increase: () => void;
  decrease: () => void;
  value: number;
}

export default function QuantitySelector({ increase, value, decrease }: QuantitySelectorProps) {
  return (
    <div className="d-flex align-items-center justify-content-center gap-4 fw-bold text-xl py-2">
      <Button
        variant="secondary"
        className="border-0 p-0 rounded-circle text-center"
        onClick={decrease}
      >
        <DashLg className="m-1 text-white" size={iconSize} />
      </Button>
      <div className="d-flex align-items-center gap-2">
        <AmountSpan price={{ unit_amount: value * 100 }} decimals={0} freeSpan={false} />
        <b>seats</b>
      </div>
      <Button variant="secondary" className="border-0 p-0 rounded-circle" onClick={increase}>
        <PlusLg className="m-1 text-white" size={iconSize}/>
      </Button>
    </div>
  );
}
